// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EndSlotButton-module__EndSlotButton__SWydh {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ds-input-field-icon-color);
    cursor: pointer;
}

.EndSlotButton-module__EndSlotButton__SWydh:disabled {
    color: var(--ds-input-field-disabled-icon-color);
    cursor: default;
}

.EndSlotButton-module__EndSlotButton__SWydh:disabled:hover {
    color: var(--ds-input-field-disabled-icon-color);
}

.EndSlotButton-module__EndSlotButton__SWydh:hover {
    color: var(--ds-input-field-focused-icon-color);
}

.EndSlotButton-module__EndSlotButton__SWydh:focus-visible {
    color: var(--ds-input-field-focused-icon-color);
    border-radius: var(--ds-border-radius-xs);
    outline: solid var(--ds-05x) var(--ds-input-field-focused-border-color);
    outline-offset: var(--ds-1x);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"EndSlotButton": `EndSlotButton-module__EndSlotButton__SWydh`
};
export default ___CSS_LOADER_EXPORT___;
